// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ajS","titleContainer":"_19ph","title":"_35Fq","icon":"_1PpS","text":"_37Db"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoItem/styles.scss
// module id = 466
// module chunks = 0